import React, { useState, useEffect, useRef } from "react";
import {
  downloadFile,
  deleteAxiosResponse,
  putAxiosResponse, getAxiosResponse, postAxiosResponse
} from "../../../services/authApiRoutes/APImethods";
import { RotatingLines } from "react-loader-spinner";
import APIUrls from "../../../services/APIUrls";
import DataTable, { createTheme } from "react-data-table-component";
import { Link, useParams } from "react-router-dom";
import { transformBlankToNull } from "../../../services/Util";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useSelector } from "react-redux";
import { updateTargetLanguage } from "../../../redux/reducers/CreateProjectTargetLanguageSlice";
import { updateSourceLanguage } from "../../../redux/reducers/CreateProjectSourceLanguageSlice";
import { departmentSelected } from "../../../redux/reducers/CreateProjectDepartmentSelectSlice";
import { updateProjectFollowers } from "../../../redux/reducers/ProjectInfoSlice";
import { updateInitializedProjectWorkflows } from "../../../redux/reducers/InitializedProjectWorkflowsSlice";
import { updateProjectInfoConfiguration } from "../../../redux/reducers/ProjectInfoConfigurationSlice";
import { updateProjectInfoValidation } from "../../../redux/reducers/ProjectInfoValidationSlice";
import { updateProjectInfo } from "../../../redux/reducers/ProjectInfoSlice";
import {projectCreationStepFilter } from '../../../redux/reducers/ProjectCreationStepSlice';
import Constants from "../../../Constants";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import $ from "jquery";
import { useTranslation } from "react-i18next";
import { getLoggedInUserRole } from "../../../services/Util";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import DateFormat from "../../../pages/DateFormat";

export default function Assets() {
  const { t } = useTranslation();
  const translate = t;
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const param = useParams();
  const popupRef = useRef(null);
  const [rowId, setRowId] = useState("");
  const [loader, setLoader] = useState(true);
  const workspaceId = param.id;
  const [assetsList, setAssetList] = useState([]);
  const [pending, setPending] = useState(true);
  const [tasks, setTasks] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [langData, setLangData] = useState([]);
  const [assetId, setAssetId] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [globalOverlay, showGlobalOverlay] = useState(false);
  const roleArray = getLoggedInUserRole();
  const paginationRef = useRef();
  const [sortFocus, setsortFocus] = useState('');
  let department;
  let intendedUseId;

  const handleChange = ({ selectedRows }) => {

    const assetIds = selectedRows.map(assets => assets.id)
    setAssetId(assetIds)
    selectedRows.length > 0 ? setAssetList(selectedRows) : setAssetList([]);
  };
  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
        <div role="row" className="no-data-display align-center">
          <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_DATA_FOUND}</p>
          </div>
        </div>
      </div>
    );
  }
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState("");



  const createProjectWithAssets = () => {
    showGlobalOverlay(true);
    Promise.all([
      getAxiosResponse(APIUrls.DEPARTMENT_URL),
      getAxiosResponse(APIUrls.INTENDED_USE),
    ]).then(async ([departmentResponse, intendedUseResponse]) => {
      if (departmentResponse.data.code === 200) {
        const data = departmentResponse.data.data;
        const minimumDepartmentId = Math.min(...data.map(x => x.id))
        const departmentToBeSet = data.filter(x => x.id === minimumDepartmentId)
        const completeDepartmentObject = {
          "path": null,
          "id": departmentToBeSet[0].id,
          "name": departmentToBeSet[0].name,
          "createdDate": null,
          "systemGroup": false
        }

        department = completeDepartmentObject;
      } else {
        throw new Error("Department API failed with response" + departmentResponse.data.code);
      }

      if (intendedUseResponse.data.code === 200) {
        const data = intendedUseResponse.data.data;
        const minimumIntendedUseId = Math.max(...data.map(x => x.id))
        intendedUseId = minimumIntendedUseId;
      } else {
        throw new Error("Intended Use API failed with response" + intendedUseResponse.data.code);
      }

      const payload = {
        "status": "CONFIGURED_BASIC_PROJECT_INFO",
        "projectFollowers": null,
        "name": "-----",
        "assetIds": assetId,
        "projectContentType": "STANDARD",
        "intendedUse": {
          "id": intendedUseId
        },
        "workspace": {
          "id": param.id
        },
        "userGroup": department,
      }

      const createProjectResponse = await postAxiosResponse(APIUrls.CREATE_PROJECT, payload);
      triggerProjectCreation(createProjectResponse.data.data)
      showGlobalOverlay(false)
    }).catch((err) => {
      handleError(err);
      showGlobalOverlay(false)
    })


  }

  const triggerProjectCreation = (data) => {

    if (!data) {
      return
    }
    const projectId = data.id;
    let projectResource = transformBlankToNull(data);
    delete projectResource["owner"];
    delete projectResource["projectFollowers"];
    if (projectResource["workspace"] && projectResource["workspace"]['workspaceMembers']) {
      delete projectResource["workspace"]['workspaceMembers'];
    }
    projectResource.name = `Project-${projectId}`;
    projectResource.intendedUse = { "id": projectResource.intendedUse.id };
    projectResource.targetLanguages = []
    putAxiosResponse(APIUrls.PROJECT(projectId), projectResource).then((res) => {
      dispatch(projectCreationStepFilter("Source Material Step 1"))
      dispatch(updateSourceLanguage({}));
      dispatch(updateTargetLanguage([]));
      dispatch(departmentSelected(""));
      dispatch(updateProjectFollowers([]));
      dispatch(updateInitializedProjectWorkflows([]));
      dispatch(updateProjectInfoValidation({}));
      dispatch(updateProjectInfoConfiguration({}));
      dispatch(updateProjectInfo({}));
      navigate(`/createProject/${projectId}`);
    });


  }

  const downloadAssets=(assets)=>{
    showGlobalOverlay(true)
    let filename=assets?.resource?.name
    downloadFile(APIUrls.ASSETS_DOWNLOAD(assets?.resource?.id),null).then(res=>{
    showGlobalOverlay(false)
    }).catch(err=>{
      showGlobalOverlay(false)
    })
  }

  const columns = [
    {
      id: "asset.name",
      name: "Name",
      minWidth: "350px",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => row.name,
    },
    {
      id: "asset.languageCount",
      name: "Languages",
      center: true,
      selector: (row) => row.languageCount,
      cell: (row) => (
        <div>
          <button
            onFocus={()=>setRowId("")}
            className="blue-text"
            onClick={() => langShow(row.id)}
            onKeyDown={(e) => handleEscFocus(e)}
            aria-expanded={rowId === row.id ? "true" : "false"}
            tabIndex="0"
            
          >
            {row.languageCount}
          </button>
          <div
            className={rowId === row.id ? "lang-hover" : "lang-hover hide"}
            id="section-display"
            ref={popupRef}
          >
            <div className="lang-inner" onKeyDown={(e)=> 
              e.code === Constants.ESCAPE ? setRowId("") : null
            }>
              <h5>Languages - {row.languageCount}</h5>
              <div style={{ textAlign: "center" }}>
                <RotatingLines
                  strokeColor="grey"
                  strokeWidth="5"
                  width="25"
                  visible={rowId === row.id && loader}
                />
              </div>
              <ul className="lang-box" ref={popupRef}>
                {langData.map((lang, index) => {
                  return (
                    <li key={index} className="langList">
                      <div className="lang flex">
                        <p>Language</p>
                        <span>{lang.displayName[0].display}</span>
                      </div>
                      <div className="lang-name lang flex w-d100">
                                <p>File Name</p>
                                <span>{lang?.resource?.name}</span>
                              </div>
                      {lang?.resource?.projectAssets !== ""
                        ? lang?.resource?.projectAssets?.map((proj, index) => {
                          return (
                            <div key={index} className="flex py-15" ref={popupRef}>
                              <div className="lang-name lang flex w-d100">
                                <p>Project Name</p>
                                <span><Link to={`/project/${proj?.project?.id}`}>{proj?.project?.name}</Link></span>
                              </div>
                              <div className="lang-btn lang flex w-d100 mar-top6" ref={popupRef}>
                                <div className="progress">
                                  {translate(`campaign_languages.${proj?.project?.status?.code}`)}
                                </div>
                              </div>
                            </div>
                          );
                        })
                        : ""}
                        <div className="lang-btn lang flex py-15">
                          <div className="btn-grp">
                            <button className="btn-default">Info</button>
                            <button onClick={()=>downloadAssets(lang)} className="dashboard-btn">Download</button>
                          </div>
                        </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      ),
    },
    {
      id: "asset.createdDateTimePeriod",
      name: "Created Date",
      wrap: true,
      sortable: true,
      center: true,
      selector: (row) => row.createdDateTimePeriod,
      cell: (row) => row.createdDateTimePeriod,
    },
    {
      id: "asset.lastModifiedDate",
      name: "Last Modified",
      wrap: true,
      sortable: true,
      center: true,
      selector: (row) => row.lastModifiedDate,
      cell: (row) => (<DateFormat date={row.lastModifiedDate}/>),
    },
    {
      id: "asset.assetType",
      name: "Type",
      wrap: true,
      sortable: true,
      center: true,
      selector: (row) => row.assetType,
      cell: (row) => row.assetType,
    },
    {
      id: "asset.action",
      name: "Action",
      center: true,
      selector: (row) => row.action,
      cell: (row) => (
        <div className="file-actions flex-center">
          <button
            onFocus={()=>setRowId("")}
            aria-label="download"
            className="download-icon"
            onClick={() => downloadAsset(row.assetFiles[0].id, row.name)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
            >
              <path
                d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                fill="#6D7080"
              ></path>
            </svg>
          </button>

          <button
            aria-label="delete"
            className={"delete-icon"}
            onClick={() =>
              row.projectCount === 0 ?confirmDelete(row.projectAssets[0]?.project?.id, row.id, row.name):confirmPopup()
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M8.20039 3.80078H11.8004C11.8004 3.32339 11.6107 2.86555 11.2732 2.52799C10.9356 2.19042 10.4778 2.00078 10.0004 2.00078C9.523 2.00078 9.06516 2.19042 8.7276 2.52799C8.39003 2.86555 8.20039 3.32339 8.20039 3.80078ZM7.00039 3.80078C7.00039 3.00513 7.31646 2.24207 7.87907 1.67946C8.44168 1.11685 9.20474 0.800781 10.0004 0.800781C10.796 0.800781 11.5591 1.11685 12.1217 1.67946C12.6843 2.24207 13.0004 3.00513 13.0004 3.80078H19.0004C19.1595 3.80078 19.3121 3.864 19.4247 3.97652C19.5372 4.08904 19.6004 4.24165 19.6004 4.40078C19.6004 4.55991 19.5372 4.71252 19.4247 4.82505C19.3121 4.93757 19.1595 5.00078 19.0004 5.00078H17.7356L16.3028 17.4136C16.2015 18.291 15.7812 19.1006 15.1218 19.6883C14.4625 20.2759 13.61 20.6007 12.7268 20.6008H7.27399C6.39074 20.6007 5.53833 20.2759 4.87895 19.6883C4.21958 19.1006 3.79927 18.291 3.69799 17.4136L2.26519 5.00078H1.00039C0.841261 5.00078 0.688648 4.93757 0.576127 4.82505C0.463605 4.71252 0.400391 4.55991 0.400391 4.40078C0.400391 4.24165 0.463605 4.08904 0.576127 3.97652C0.688648 3.864 0.841261 3.80078 1.00039 3.80078H7.00039ZM4.88959 17.2768C4.9573 17.8617 5.23765 18.4012 5.67729 18.7929C6.11694 19.1845 6.68521 19.4009 7.27399 19.4008H12.7268C13.3156 19.4009 13.8838 19.1845 14.3235 18.7929C14.7631 18.4012 15.0435 17.8617 15.1112 17.2768L16.5272 5.00078H3.47359L4.88959 17.2768ZM8.20039 8.00078C8.35952 8.00078 8.51213 8.06399 8.62466 8.17652C8.73718 8.28904 8.80039 8.44165 8.80039 8.60078V15.8008C8.80039 15.9599 8.73718 16.1125 8.62466 16.225C8.51213 16.3376 8.35952 16.4008 8.20039 16.4008C8.04126 16.4008 7.88865 16.3376 7.77613 16.225C7.6636 16.1125 7.60039 15.9599 7.60039 15.8008V8.60078C7.60039 8.44165 7.6636 8.28904 7.77613 8.17652C7.88865 8.06399 8.04126 8.00078 8.20039 8.00078ZM12.4004 8.60078C12.4004 8.44165 12.3372 8.28904 12.2247 8.17652C12.1121 8.06399 11.9595 8.00078 11.8004 8.00078C11.6413 8.00078 11.4886 8.06399 11.3761 8.17652C11.2636 8.28904 11.2004 8.44165 11.2004 8.60078V15.8008C11.2004 15.9599 11.2636 16.1125 11.3761 16.225C11.4886 16.3376 11.6413 16.4008 11.8004 16.4008C11.9595 16.4008 12.1121 16.3376 12.2247 16.225C12.3372 16.1125 12.4004 15.9599 12.4004 15.8008V8.60078Z"
                fill="#6D7080"
              ></path>
            </svg>
          </button>
          {/* <div className="gb-tooltip">
            <button aria-label="tooltip">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
                  fill="#64748B"
                ></path>
                <path
                  d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z"
                  fill="#64748B"
                ></path>
              </svg>
            </button>
            <div className="wrap-tooltip-content">
              <div className="triangle"></div>
              <div className="gb-tooltip-content">
                <p>You can customize the list</p>
              </div>
            </div>
          </div> */}
        </div>
      ),
    },
  ];
  const langShow = (id) => {
    if(rowId !== id){
      $('.datatable-block').addClass('overflowHide')
      $(document).on("click",".blue-text",function() {
         $(this).addClass('langfocusAdd');
      });
      $(".blue-text").attr("aria-expanded", "true");
    }
    else{
      $('.datatable-block').removeClass('overflowHide')
      setTimeout(() => {
        $('.blue-text').removeClass('langfocusAdd');
      }, 200);
      $(".blue-text").attr("aria-expanded", "false");
    }
    setLangData([]);
    setRowId(id);
    setLoader(true);
    rowId !== id
      ? getAxiosResponse(APIUrls.CAMPAIGN_ASSET_LANGUAGE_DETAIL(id))
        .then((res) => {
          if (res.data.data && res.data !== "") {
            setLangData(res.data.data);
          }
          setLoader(false);
        })
        .catch((err) => {
          handleError(err);
        })
      : setRowId("");
     
  };
  const fetchTaskData = async (page) => {
    //setPending(true);
    await getAxiosResponse(
      APIUrls.CAMPAIGN_ASSETS +
      `?page=${page}&workspaceId=${workspaceId}${sort}&pageSize=${perPage}`
    )
      .then((res) => {
        if (res.data !== "") {
          setTasks(res.data.data.result);
          setTotalRows(res.data.data.resultCount);
          setTimeout(() => {
            if(sortFocus){
              setsortFocus('');
            }
            else if (paginationRef.current) {
                $('#'+ paginationRef.current).trigger('focus');
                paginationRef.current = '';
            }
          }, 300);
        } else {
          setTasks([]);
        }
      })
      .catch((err) => {
handleError(err)
      });
    setPending(false);
  };
  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
    .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
    //setPending(true);
    var order = sortDirection.toUpperCase();
    var sortedColumn = column.id;
    var sortedString = `&sortOrder=${order}&sortColumn=${sortedColumn}`;
    setSort(sortedString);
    setsortFocus(column.id);
  };
  $(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
    $(".rdt_Table").attr("aria-label","Campaign Assets"); 
    $('.rdt_Table input').parent().attr("role","cell")
    })
  const handlePageChange = (paging) => {
    setPending(true);
    setCurrentPage(paging);
    if ($('#pagination-last-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-previous-page').attr('id');
    } else if ($('#pagination-first-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-next-page').attr('id');
    } else {
      paginationRef.current = document.activeElement.id;
    }
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    setPending(true);
    await getAxiosResponse(
      APIUrls.CAMPAIGN_ASSETS +
      `?page=${page}&pageSize=${newPerPage}${sort}&workspaceId=${workspaceId}`
    )
      .then((res) => {
        if (res.data !== "") {
          setTasks(res.data.data.result);
          setPerPage(newPerPage);
          setTimeout(function(){
            $('.datatable-block nav.rdt_Pagination select').trigger('focus');
          }, 100);
          setPending(false);
        }
      })
      .catch((err) => {
        handleError(err);
      });
    setPending(false);
  };
  const downloadAsset = (asset_id, file_name) => {
    showGlobalOverlay(true)
    downloadFile(APIUrls.DOWNLOAD_ASSET_CAMPAIGN_DETAIL(asset_id), file_name).then(res=>{
    showGlobalOverlay(false)
    }).catch(err=>{
    showGlobalOverlay(false)
    })
  };
  $(document).on("click",".datatable-block .rdt_TableCell button.delete-icon",function() {
    $(this).addClass('focusAdd');
   });
  const confirmDelete = (project_id, asset_id, file_name) => {
    setTimeout(() => {
      $("#deleteNo").trigger("focus");
      $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Confirm Delete"} );
    }, 500);
    confirmAlert({
      title: "Confirm Delete",
      message: <p>{`Do you want to delete this asset.`}</p>,
      buttons: [
        {
          label: "Yes",
          id: "deleteYes",
          onClick: () =>
            deleteAxiosResponse(APIUrls.ASSET(project_id, asset_id)),
            onKeyDown: (e) => {
              if (e.key === "Tab") {
                if (e.shiftKey === true) {
                  e.preventDefault();
                  $("#deleteNo").trigger("focus");
                }
              }
            },
        },
        {
          label: "No",
          id: "deleteNo",
          onClick: () => {
            $('.focusAdd').trigger('focus');
            $('.delete-icon').removeClass('focusAdd');
          },
          onKeyDown: (e) => {
            if (e.key === "Tab") {
              if (e.shiftKey === false) {
                e.preventDefault();
                $("#deleteYes").trigger("focus");
              }
            }
            if (e.key === Constants.ESCAPE) {
              $('.focusAdd').trigger('focus');
              $('.delete-icon').removeClass('focusAdd');
            }
          },
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
  };

  const confirmPopup=()=>{
    setTimeout(() => {
      $("#deleteNo").trigger("focus");
      $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Confirm Delete"} );
    }, 500);
    confirmAlert({
      title: "Unable to delete asset",
      message: <p>{`This asset is part of one or more projects and cannot be deleted.`}</p>,
      buttons: [
        {
          label: "OK",
          id: "deleteYes",
          onClick: () => {
            $('.focusAdd').trigger('focus');
            $('.delete-icon').removeClass('focusAdd');
          },
          onKeyDown: (e) => {
            if (e.key === "Tab") {
              if (e.shiftKey === false) {
                e.preventDefault();
                $("#deleteYes").trigger("focus");
              }
            }
            if (e.key === Constants.ESCAPE) {
              $('.focusAdd').trigger('focus');
              $('.delete-icon').removeClass('focusAdd');
            }
          },
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
  }


  useEffect(() => {
    const body = document.querySelector("body"); 
     const handleClickOutside = (event) => {
      setTimeout(() => {
        $('.lang-hover.hide').prev().attr("aria-expanded", "false");
       }, 200);
       $(document).mouseup(function(e) {
        var bannerCont = $('.lang-inner');
        if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
          setRowId("");
          $('.datatable-block').removeClass('overflowHide')
          $(".blue-text").attr("aria-expanded", "false");
          $('.langfocusAdd').trigger('focus');
          $('.blue-text').removeClass('langfocusAdd');
        }
      });
    };
    const handleEscape = (event) => {
      if (event.key === "Escape" && popupRef?.current?.contains(event.target)) {
        setRowId("");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("keydown", handleEscape, true);
    return () => {
     // document.removeEventListener("click", handleClickOutside, false);
      document.addEventListener("keydown", handleEscape, false);
    };
  }, [popupRef]);
  const handleEscFocus = (event) => {
    if (event.key === Constants.ESCAPE) {
      setRowId("");
      $('.blue-text').removeClass('langfocusAdd');
    }
 }
 useEffect(()=>{
     setTimeout(() => {
      if($('.langfocusAdd').next().hasClass('hide')){
        $('.langfocusAdd').trigger('focus');
        $('.blue-text').removeClass('langfocusAdd');
      }
    });
 },[rowId])
  
  useEffect(() => {
    fetchTaskData(currentPage);
  }, [
    currentPage,
    sort,
  ]);


  const createAssetsPopup = (assets) => {
    setTimeout(() => {
      $("#deleteNo").trigger("focus");
      $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Confirm Delete"} );
    }, 500);
    confirmAlert({
      title: "Start New Project",
      message: <div className="assets-padding"><h6>{`Create a project with these assets:`}</h6>
      <br></br>
        <ul>
        {assets.map((data,index)=>(
          <li key={index}>{data?.name}</li>
        ))}
        </ul>

      </div>,
      buttons: [
        {
          label: "Create Project",
          id: "deleteYes",
          onClick: () =>createProjectWithAssets(),
            onKeyDown: (e) => {
              if (e.key === "Tab") {
                if (e.shiftKey === true) {
                  e.preventDefault();
                  $("#deleteNo").trigger("focus");
                }
              }
            },
        },
        {
          label: "No",
          id: "deleteNo",
          onClick: () => {
            $('.focusAdd').trigger('focus');
            $('.delete-icon').removeClass('focusAdd');
          },
          onKeyDown: (e) => {
            if (e.key === "Tab") {
              if (e.shiftKey === false) {
                e.preventDefault();
                $("#deleteYes").trigger("focus");
              }
            }
            if (e.key === Constants.ESCAPE) {
              $('.focusAdd').trigger('focus');
              $('.delete-icon').removeClass('focusAdd');
            }
          },
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
  };




  return (
    <>
      <div className="listing-content">
        <div className="campaign_details-asset">
          <div className="projects-heading">
            <h5>{translate("campaign_page.campaign_assets")}</h5>
            <div className="btn-wrap">
              {assetsList?.length > 0 ? (
                <button onClick={() => createAssetsPopup(assetsList)} className="dashboard-btn blue">
                  <svg
                    className="plus-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path
                      d="M6 1V11"
                      stroke="#1D4ED8"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M1 6H11"
                      stroke="#1D4ED8"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  Add to Projects
                </button>
              ) : (
                ""
              )}
              <div className="global-dropdown-select"></div>
              {/* <button className="dashboard-btn">
              <svg
                className="plus-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <path
                  d="M6 1V11"
                  stroke="#1D4ED8"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M1 6H11"
                  stroke="#1D4ED8"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              Add Assets
            </button> */}
            </div>
          </div>
          <div className="projects-content">
            <div className="datatable-block">
              <DataTable
                keyField="id"
                columns={columns}
                data={tasks}
                selectableRows
                defaultSortFieldId={1}
                responsive
                striped
                // selectableRowsHighlight={true}
                onSelectedRowsChange={handleChange}
                pagination
                onSort={handleSort}
                pointerOnHover={true}
                // onRowClicked={(row, event) => {
                //    rowClicked(row, event);
                // }}
                //customStyles={customStyles}
                noDataComponent={noDataFoundComponent()}
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                paginationRowsPerPageOptions={[10, 20, 40, 50, 100, 200]}
                onChangePage={handlePageChange}
                progressPending={pending}
              // subHeader
              // subHeaderComponent={subHeaderComponent}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>
    </>
  );

}
